// extracted by mini-css-extract-plugin
export default {"partonBlockForm":"partonBlockForm---vMbIX","partonBlockWrapperHolder":"partonBlockWrapperHolder---JzGA9","partonBlockWrapper":"partonBlockWrapper---Wyb5v"};